<!-- Hero section -->
<div class="relative isolate overflow-hidden pt-14">
  <img src="{{ assetsUrl }}/images/before_after_comparison.png" alt="Pressure Washing Before and After"
    class="absolute inset-0 -z-10 size-full object-cover opacity-30" />
  <div class="absolute inset-0 bg-black/70"></div>
  <div aria-hidden="true" class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
    <div
      style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
      class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
    </div>
  </div>
  <div class="mx-auto max-w-7xl px-6 lg:px-8 relative">
    <div class="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
      <div class="text-center">
        <h1 class="text-balance text-5xl font-semibold tracking-tight text-white sm:text-7xl">The Royal Treatment:
          Delivered</h1>
        <p class="mt-8 text-pretty text-lg font-medium text-gray-400 sm:text-xl/8">Professional Power Washing Services for Residential and Commercial Customers</p>
        <div class="hidden sm:mb-8 sm:flex sm:justify-center">
          <div class="relative px-3 py-1 text-sm/6 text-gray-400">
            Serving the greater Charlotte, NC area. 
          </div>
        </div>
      </div>
    </div>
  </div>
  <div aria-hidden="true"
    class="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
    <div
      style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
      class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-20 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
    </div>
  </div>
</div>

<!-- Packages Section -->
<div id="packages" class="bg-gray-900 py-24 sm:py-32">
  <div class="mx-auto max-w-7xl px-6 lg:px-8">
    <div class="mx-auto max-w-4xl sm:text-center">
      <h2 class="text-base/7 font-semibold text-indigo-400">Packages</h2>
      <p class="mt-2 text-pretty text-5xl font-semibold tracking-tight text-white sm:text-balance sm:text-6xl">Packages
        built to fit your needs</p>
    </div>
    <p class="mx-auto mt-6 max-w-2xl text-pretty text-lg font-medium text-gray-400 sm:text-center sm:text-xl/8">
      Thoughtfully crafted packages that deliver quality and value.</p>
    <!-- <p class="mx-auto mt-6 max-w-2xl text-pretty text-lg font-medium text-gray-400 sm:text-center sm:text-xl/8">Thoughtfully crafted packages that deliver quality and value.</p> -->
    <div class="mt-20 flow-root">
      <div
        class="isolate mx-auto mt-10 grid max-w-md grid-cols-1 gap-8 sm:mx-auto sm:max-w-sm sm:grid-cols-1 md:max-w-none md:grid-cols-3 lg:max-w-none lg:mx-0 xl:mx-0 xl:max-w-none xl:grid-cols-3">
        <!-- <div class="isolate mx-auto mt-16 grid max-w-sm grid-cols-1 gap-y-16 divide-y divide-white/10 sm:mx-auto lg:-mx-8 lg:mt-0 lg:max-w-none lg:grid-cols-3 lg:divide-x lg:divide-y-0 xl:-mx-4"> -->
        <!-- <div class="pt-16 lg:px-8 lg:pt-0 xl:px-14"> -->
        <div
          class="group/tier rounded-3xl bg-gray-800/50 p-8 ring-1 ring-white/15 data-[featured]:ring-2 data-[featured]:ring-indigo-400">
          <div class="flex items-center justify-between gap-x-4">
            <h3 id="tier-crown-refresh" class="text-base/7 font-semibold text-white">Crown Refresh</h3>
            <p
              class="rounded-full bg-indigo-500 px-2.5 py-1 text-xs/5 font-semibold text-white group-[:not([data-featured])]/tier:hidden">
              Most popular</p>
            <!-- <p class="mt-6 flex items-baseline gap-x-1"> -->
            <!-- <span class="text-5xl font-semibold tracking-tight text-white">$19</span> -->
            <!-- <span class="text-sm/6 font-semibold text-gray-400">/month</span> -->
            <!-- </p> -->
            <!-- <p class="mt-3 text-sm/6 text-gray-400">$15 per month if paid annually</p> -->
            <!-- <a href="#" aria-describedby="tier-basic" class="mt-10 block rounded-md bg-indigo-500 px-3 py-2 text-center text-sm/6 font-semibold text-white hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400">Buy plan</a> -->
          </div>
          <p class="mt-2 text-sm/6 font-semibold text-white">Package includes</p>
          <ul role="list" class="mt-6 space-y-3 text-sm/6 text-gray-300">
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              House Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Standard Chemical Treatment
            </li>
            <!-- <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="h-6 w-5 flex-none text-indigo-400">
                <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-slot="icon" aria-hidden="true" class="h-6 w-5 flex-none text-indigo-400">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
              </svg>
              Basic analytics
            </li> -->
            <!-- <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="h-6 w-5 flex-none text-indigo-400">
                <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z" clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              48-hour support response time
            </li> -->
          </ul>
        </div>
        <!-- <div class="pt-16 lg:px-8 lg:pt-0 xl:px-14"> -->
        <div data-featured="true"
          class="group/tier rounded-3xl bg-gray-800/50 p-8 ring-1 ring-white/15 data-[featured]:ring-2 data-[featured]:ring-indigo-400">
          <div class="flex flex-wrap items-center justify-between gap-x-4 flex">
            <h3 id="tier-crown-restore" class="text-base/7 font-semibold text-white">Crown Restore</h3>
            <p
              class="rounded-full bg-indigo-500 px-2.5 py-1 text-xs/5 font-semibold text-white group-[:not([data-featured])]/tier:hidden">
              Most popular</p>
            <!-- <p class="rounded-full bg-indigo-500 px-2.5 py-1 text-xs/5 font-semibold text-white group-[:not([data-featured])]/tier:hidden">Most popular</p> -->
            <!-- <p class="mt-6 flex items-baseline gap-x-1"> -->
            <!-- <span class="text-5xl font-semibold tracking-tight text-white">$49</span>
              <span class="text-sm/6 font-semibold text-gray-400">/month</span> -->
            <!-- </p> -->
            <!-- <p class="mt-3 text-sm/6 text-gray-400">$39 per month if paid annually</p> -->
            <!-- <a href="#" aria-describedby="tier-essential" class="mt-10 block rounded-md bg-indigo-500 px-3 py-2 text-center text-sm/6 font-semibold text-white hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400">Buy plan</a> -->
          </div>
          <p class="mt-2 text-sm/6 font-semibold text-white">Package includes</p>
          <ul role="list" class="mt-6 space-y-3 text-sm/6 text-gray-300">
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              House Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Driveway Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Sidewalk Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Curb Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Standard Chemical Treatment
            </li>
          </ul>
        </div>
        <!-- <div class="pt-16 lg:px-8 lg:pt-0 xl:px-14"> -->
        <div
          class="group/tier rounded-3xl bg-gray-800/50 p-8 ring-1 ring-white/15 data-[featured]:ring-2 data-[featured]:ring-indigo-400">
          <div class="flex items-center justify-between gap-x-4">
            <h3 id="tier-crown-signature" class="text-base/7 font-semibold text-white">Crown Signature</h3>
            <p
              class="rounded-full bg-indigo-500 px-2.5 py-1 text-xs/5 font-semibold text-white group-[:not([data-featured])]/tier:hidden">
              Most popular</p>
            <!-- <p class="mt-6 flex items-baseline gap-x-1"> -->
            <!-- <span class="text-5xl font-semibold tracking-tight text-white">$99</span>
              <span class="text-sm/6 font-semibold text-gray-400">/month</span> -->
            <!-- </p> -->
            <!-- <p class="mt-3 text-sm/6 text-gray-400">$79 per month if paid annually</p> -->
            <!-- <a href="#" aria-describedby="tier-growth" class="mt-10 block rounded-md bg-indigo-500 px-3 py-2 text-center text-sm/6 font-semibold text-white hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-400">Buy plan</a> -->
          </div>
          <p class="mt-2 text-sm/6 font-semibold text-white">Package includes</p>
          <ul role="list" class="mt-6 space-y-3 text-sm/6 text-gray-300">
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              House Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Driveway Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Sidewalk Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Curb Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Gutter Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Waste Receptacle Wash
            </li>
            <li class="flex gap-x-3">
              <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                class="h-6 w-5 flex-none text-indigo-400">
                <path
                  d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
              Standard Chemical Treatment
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Services section -->
<div id="services" class="mx-auto mt-20 mb-20 max-w-7xl px-6 lg:px-8">
  <div class="mx-auto max-w-2xl lg:text-center">
    <h2 class="text-base/7 font-semibold text-indigo-600">Services</h2>
    <p class="mt-2 text-pretty text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance">Can't
      find a package that works for you?</p>
    <p class="mt-6 text-lg/8 text-gray-600">Crown Wash offers a wide range of services: à la carte or package add-ons.
    </p>
  </div>

  <div class="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
    <dl class="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          House Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
          <p class="flex-auto">Safely remove dirt, algae, mold, and buildup from your home's exterior with our
            professional soft wash process, restoring curb appeal without damaging siding or surfaces.</p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Driveway Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
          <p class="flex-auto">Bring your driveway back to life by removing years of dirt, stains, algae, and grime for
            a cleaner, brighter appearance that instantly improves curb appeal.</p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Sidewalk Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
          <p class="flex-auto">Clean, bright sidewalks make a huge difference. We remove buildup, discoloration, and
            slippery surface growth to leave your walkways looking fresh and safe.</p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Curb Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
          <p class="flex-auto">Restore the clean edge of your property with professional curb cleaning that removes
            dirt, runoff stains, algae, and roadway buildup for a polished look.</p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Gutter Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
          <p class="flex-auto">Eliminate ugly “tiger stripes,” stains, and exterior buildup from your gutters with a
            detailed exterior wash that restores a brighter, cleaner finish.</p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Waste Receptacle Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
          <p class="flex-auto">Deep-clean and sanitize trash bins to remove grime, bacteria, odors, and buildup,
            leaving your waste receptacles cleaner, fresher, and more hygienic.</p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Roof Wash
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
            <p class="flex-auto">Our roof cleaning service provides effective maintenance that safely removes algae, moss, and debris buildup to restore your roof's
              appearance.
            </p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Standard Chemical Treatment
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
            <p class="flex-auto">Our standard chemical treatment is designed to effectively eliminate mold, algae, and mildew from exterior surfaces, providing a thorough cleaning and protection.
            </p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
      <div class="flex flex-col">
        <dt class="text-base/7 font-semibold text-gray-900">
          Enhanced Chemical Treatment
        </dt>
        <dd class="mt-1 flex flex-auto flex-col text-base/7 text-gray-600">
            <p class="flex-auto">Our enhanced chemical treatment is designed to provide a more powerful solution for
              more specialized contaminates such as grease, oil, red clay, oxidation, and other tough stains.
            </p>
          <p class="mt-6">
            <!-- <a href="#" class="text-sm/6 font-semibold text-indigo-600 hover:text-indigo-500">Learn more <span aria-hidden="true">→</span></a> -->
          </p>
        </dd>
      </div>
    </dl>
  </div>
</div>

<!-- faq -->
<div id="faq" class="bg-gray-900">
  <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8 lg:py-40">
    <div class="mx-auto max-w-4xl">
      <h2 class="text-4xl font-semibold tracking-tight text-white sm:text-5xl">Frequently asked questions</h2>
      <dl class="mt-16 divide-y divide-white/10">
        <div class="py-6 first:pt-0 last:pb-0">
          <dt>
            <button type="button" aria-controls="faq-0" [attr.aria-expanded]="isFaqExpanded('faq-0') ? 'true' : 'false'"
              class="flex w-full items-start justify-between text-left text-white" (click)="buttonClicked('faq-0')">
              <span class="text-base/7 font-semibold">What's the difference between pressure washing and soft
                washing?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg *ngIf="!isFaqExpanded('faq-0')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg *ngIf="isFaqExpanded('faq-0')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </dt>
          <div id="faq-0" [hidden]="!isFaqExpanded('faq-0')" class="[&:not([hidden])]:contents">
            <dd class="mt-2 pr-12">
              <p class="text-base/7 text-gray-400">Soft washing uses low pressure combined with specialized cleaning
                solutions to safely remove mold, algae, dirt, and buildup from delicate surfaces like siding and roofs.
                Pressure washing uses higher pressure for tougher surfaces like concrete and driveways as well as cleaning solution application for enhanced results.</p>
            </dd>
          </div>
        </div>
        <div class="py-6 first:pt-0 last:pb-0">
          <dt>
            <button type="button" aria-controls="faq-1" [attr.aria-expanded]="isFaqExpanded('faq-1') ? 'true' : 'false'"
              class="flex w-full items-start justify-between text-left text-white" (click)="buttonClicked('faq-1')">
              <span class="text-base/7 font-semibold">How often should a home, driveway, sidewalk, etc, be
                cleaned?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg *ngIf="!isFaqExpanded('faq-1')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg *ngIf="isFaqExpanded('faq-1')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </dt>
          <div id="faq-1" [hidden]="!isFaqExpanded('faq-1')" class="[&:not([hidden])]:contents">
            <dd class="mt-2 pr-12">
              <p class="text-base/7 text-gray-400">The frequency of cleaning depends on various factors such as
                location, weather conditions, and the type of surface. Generally, it's recommended to clean your home
                exterior, driveway, and sidewalks at least once a year to maintain their appearance and prevent buildup
                of dirt, mold, and algae.</p>
            </dd>
          </div>
        </div>
        <!-- <div class="py-6 first:pt-0 last:pb-0">
          <dt>
            <button type="button" command="--toggle" commandfor="faq-2" class="flex w-full items-start justify-between text-left text-white" (click)="buttonClicked($event, 'faq-2')">
              <span class="text-base/7 font-semibold">What do you call someone with no body and no nose?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6 [[aria-expanded='true']_&]:hidden">
                  <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6 [&:not([aria-expanded='true']_*)]:hidden">
                  <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </dt>
          <div id="faq-2" hidden class="[&:not([hidden])]:contents">
            <dd class="mt-2 pr-12">
              <p class="text-base/7 text-gray-400">Nobody knows. Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa, voluptas ipsa quia excepturi, quibusdam natus exercitationem sapiente tempore labore voluptatem.</p>
            </dd>
          </div>
        </div> -->
        <div class="py-6 first:pt-0 last:pb-0">
          <dt>
            <button type="button" aria-controls="faq-3" [attr.aria-expanded]="isFaqExpanded('faq-3') ? 'true' : 'false'"
              class="flex w-full items-start justify-between text-left text-white" (click)="buttonClicked('faq-3')">
              <span class="text-base/7 font-semibold">How is pricing determined?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg *ngIf="!isFaqExpanded('faq-3')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg *ngIf="isFaqExpanded('faq-3')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </dt>
          <div id="faq-3" [hidden]="!isFaqExpanded('faq-3')" class="[&:not([hidden])]:contents">
            <dd class="mt-2 pr-12">
              <p class="text-base/7 text-gray-400">Pricing is determined based on factors such as the size of the area
                to be cleaned, the type of surfaces, the level of dirt and grime, and any additional services requested.
                We provide customized quotes to ensure fair and transparent pricing for each project.</p>
            </dd>
          </div>
        </div>
        <div class="py-6 first:pt-0 last:pb-0">
          <dt>
            <button type="button" aria-controls="faq-4" [attr.aria-expanded]="isFaqExpanded('faq-4') ? 'true' : 'false'"
              class="flex w-full items-start justify-between text-left text-white" (click)="buttonClicked('faq-4')">
              <span class="text-base/7 font-semibold">Is your cleaning process safe for my home and landscaping?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg *ngIf="!isFaqExpanded('faq-4')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg *ngIf="isFaqExpanded('faq-4')" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6">
                  <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </dt>
          <div id="faq-4" [hidden]="!isFaqExpanded('faq-4')" class="[&:not([hidden])]:contents">
            <dd class="mt-2 pr-12">
              <p class="text-base/7 text-gray-400">Our cleaning process is designed to be safe for your home and
                landscaping. We have several different chemical and detergent options, as well as a variety of pressure techniques for different surfaces,
                ensuring that your property is protected while achieving effective results.</p>
            </dd>
          </div>
        </div>
        <!-- <div class="py-6 first:pt-0 last:pb-0">
          <dt>
            <button type="button" command="--toggle" commandfor="faq-5" class="flex w-full items-start justify-between text-left text-white" (click)="buttonClicked($event, 'faq-5')">
              <span class="text-base/7 font-semibold">Why did the invisible man turn down the job offer?</span>
              <span class="ml-6 flex h-7 items-center">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6 [[aria-expanded='true']_&]:hidden">
                  <path d="M12 6v12m6-6H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" data-slot="icon" aria-hidden="true" class="size-6 [&:not([aria-expanded='true']_*)]:hidden">
                  <path d="M18 12H6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </button>
          </dt>
          <div id="faq-5" hidden class="[&:not([hidden])]:contents">
            <dd class="mt-2 pr-12">
              <p class="text-base/7 text-gray-400">He couldn&#039;t see himself doing it. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet perspiciatis officiis corrupti tenetur. Temporibus ut voluptatibus, perferendis sed unde rerum deserunt eius.</p>
            </dd>
          </div>
        </div> -->
      </dl>
    </div>
  </div>
</div>

<!-- contact -->
 @if (!formSubmitted) {
<div id="contact" class="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
  <!-- <div aria-hidden="true" class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
    <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" class="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"></div>
  </div> -->
  <div class="mx-auto max-w-2xl text-center">
    <h2 class="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Contact us</h2>
    <p class="mt-2 text-lg/8 text-gray-600">Fill out the form below for appointment scheduling and general inquiries.</p>
    <p class="mt-2 text-lg/8 text-gray-600">Or, if you prefer, you can call or text us at <a href="tel:+17042189659">(704) 218-9659</a> and email us at <a href="mailto:contact@crownwash.com">contact@crownwash.com</a>.</p>
  </div>
  <form id="contactForm" [formGroup]="contactForm" (ngSubmit)="onSubmit($event)" class="mx-auto mt-16 max-w-xl sm:mt-20">
    <div class="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
      <div class="sm:col-span-2">
        <fieldset>
          <!-- <legend class="text-sm/6 font-semibold text-gray-900">Notifications</legend> -->
          <!-- <p class="mt-1 text-sm/6 text-gray-600">How do you prefer to receive notifications?</p> -->
          <div class="flex items-center gap-x-6 mt-4">
            <div class="flex items-center mx-auto">
              <input id="residential" formControlName="customerType" type="radio" name="customerType" value="residential" class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden" />
              <label for="residential" class="ml-3 block text-sm/6 font-medium text-gray-900">Residential</label>
            </div>
            <div class="flex items-center mx-auto">
              <input id="commercial" formControlName="customerType" type="radio" name="customerType" value="commercial" class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden" />
              <label for="commercial" class="ml-3 block text-sm/6 font-medium text-gray-900">Commercial</label>
            </div>
          </div>
        </fieldset>
      </div>
      <div>
        <label for="first-name" class="block text-sm/6 font-semibold text-gray-900">
          First name
        </label>
        <div class="mt-2.5">
          <input id="first-name" type="text" autocomplete="given-name" formControlName="firstName" class="form-input" />
        </div>
        <p *ngIf="hasError('firstName')" class="error-text">First name is required.</p>
      </div>

      <div>
        <label for="last-name" class="block text-sm/6 font-semibold text-gray-900">
          Last name
        </label>
        <div class="mt-2.5">
          <input id="last-name" type="text" autocomplete="family-name" formControlName="lastName" class="form-input" />
        </div>
        <p *ngIf="hasError('lastName')" class="error-text">Last name is required.</p>
      </div>

      <div class="sm:col-span-2">
        <label for="address" class="block text-sm/6 font-semibold text-gray-900">
          Address
        </label>
        <div class="mt-2.5">
          <input id="address" type="text" autocomplete="address-line1" formControlName="address" class="form-input" />
        </div>
        <p *ngIf="hasError('address')" class="error-text">Address is required.</p>
      </div>
      <div class="sm:col-span-2">
        <label for="address2" class="block text-sm/6 font-semibold text-gray-900">
          Address Line 2
        </label>
        <div class="mt-2.5">
          <input id="address2" type="text" autocomplete="address-line2" formControlName="address2" class="form-input" />
        </div>
        <p *ngIf="hasError('address2')" class="error-text">Address Line 2 is required.</p>
      </div>
      <div>
        <label for="city" class="block text-sm/6 font-semibold text-gray-900">
          City
        </label>
        <div class="mt-2.5">
          <input id="city" type="text" autocomplete="address-level2" formControlName="city" class="form-input" />
        </div>
        <p *ngIf="hasError('city')" class="error-text">City is required.</p>
      </div>

      <div>
        <label for="state" class="block text-sm/6 font-semibold text-gray-900">
          State
        </label>
        <div class="mt-2 grid grid-cols-1">
          <!-- <input
          id="state"
          type="text"
          autocomplete="address-level1"
          formControlName="state"
          class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-sm/6"
        /> -->
          <select formControlName="state" id="state" autocomplete="address-level1"
            class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-indigo-600 sm:text-sm/6">
            <option *ngFor="let state of states" [value]="state.ansi">
              {{ state.unabbreviated }}
            </option>
          </select>
          <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
            class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4">
            <path
              d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
              clip-rule="evenodd" fill-rule="evenodd" />
          </svg>
        </div>
        <p *ngIf="hasError('state')" class="error-text">State is required.</p>
      </div>

      <div>
        <label for="zipCode" class="block text-sm/6 font-semibold text-gray-900">
          Zip Code
        </label>
        <div class="mt-2.5">
          <input id="zipCode" type="text" autocomplete="postal-code" formControlName="zipCode" class="form-input" />
        </div>
        <p *ngIf="hasError('zipCode')" class="error-text">
          Enter a valid ZIP code.
        </p>
      </div>

      <div>
        <label for="county" class="block text-sm/6 font-semibold text-gray-900">
          County
        </label>
        <div class="mt-2.5">
          <input id="county" type="text" autocomplete="address-level2" formControlName="county" class="form-input" />
        </div>
      </div>

      <div>
        <label for="subdivision" class="block text-sm/6 font-semibold text-gray-900">
          Subdivision/Neighborhood
        </label>
        <div class="mt-2.5">
          <input id="subdivision" type="text" autocomplete="address-level3" formControlName="subdivision"
            class="form-input" />
        </div>
      </div>

      <div class="sm:col-span-2">
        <label for="email" class="block text-sm/6 font-semibold text-gray-900">
          Email
        </label>
        <div class="mt-2.5">
          <input id="email" type="email" autocomplete="email" formControlName="email" class="form-input" />
        </div>
        <p *ngIf="hasError('email')" class="error-text">
          Enter a valid email address.
        </p>
      </div>

      <div class="sm:col-span-2">
        <label for="phone-number" class="block text-sm/6 font-semibold text-gray-900">
          Phone number
        </label>

        <div class="mt-2.5">
          <div
            class="flex rounded-md bg-white outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-indigo-600">
            <div class="grid shrink-0 grid-cols-1 focus-within:relative">
              <select id="country" autocomplete="country" aria-label="Country" formControlName="country"
                class="col-start-1 row-start-1 w-full appearance-none rounded-md py-2 pl-3.5 pr-7 text-base text-gray-500 focus:outline-none sm:text-sm/6">
                <option *ngFor="let country of countries" [value]="country">
                  {{ country }}
                </option>
              </select>

              <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"
                class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4">
                <path
                  d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z"
                  clip-rule="evenodd" fill-rule="evenodd" />
              </svg>
            </div>

            <input id="phone-number" type="text" placeholder="123-456-7890" formControlName="phoneNumber" appPhoneFormat
              class="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6" />
          </div>
        </div>

        <p *ngIf="hasError('phoneNumber')" class="error-text">
          Enter a valid phone number.
        </p>
      </div>

      <div class="sm:col-span-2">
        <label for="message" class="block text-sm/6 font-semibold text-gray-900">
          Message
        </label>
        <div class="mt-2.5">
          <textarea id="message" rows="4" formControlName="message" class="form-input"></textarea>
        </div>
        <p *ngIf="hasError('message')" class="error-text">Message is required.</p>
      </div>

      
      <fieldset>
        <legend class="block text-sm/6 font-semibold text-gray-900">
          Preferred contact method
        </legend>
        
        <div class="mt-4 space-y-4">
          <div *ngFor="let method of contactMethods" class="flex items-center gap-x-3">
            <div class="min-w-0 flex-1 text-sm/6">
              <label [for]="'contact-method-' + method.value" class="select-none font-medium text-gray-900">
                {{ method.label }}
              </label>
            </div>
            
            <div class="flex h-6 shrink-0 items-center">
              <div class="group grid size-4 grid-cols-1">
                <input
                [id]="'contact-method-' + method.value"
                name="preferredContactMethod"
                type="checkbox"
                [value]="method.value"
                [checked]="isPreferredContactMethodSelected(method.value)"
                (change)="onPreferredContactMethodChange($event, method.value)"
                class="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                />
                <svg viewBox="0 0 14 14" fill="none"
                class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white">
                <path d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="opacity-0 group-has-[:checked]:opacity-100" />
              </svg>
            </div>
          </div>
        </div>
        <p *ngIf="hasError('preferredContactMethod')" class="error-text">
          Please select a preferred contact method.
        </p>
      </div>
    </fieldset>

    <div class="flex gap-x-4 sm:col-span-2">
      <div class="flex h-6 items-center">
        <div
          class="group relative inline-flex w-8 shrink-0 rounded-full bg-gray-200 p-px outline-offset-2 outline-indigo-600 ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out has-[:checked]:bg-indigo-600 has-[:focus-visible]:outline has-[:focus-visible]:outline-2">
          <span
            class="size-4 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-[:checked]:translate-x-3.5"></span>
  
          <input id="agree-to-policies" type="checkbox" aria-label="Agree to policies"
            formControlName="agreeToPolicies" class="absolute inset-0 size-full appearance-none focus:outline-none" />
        </div>
      </div>
  
      <label for="agree-to-policies" class="text-sm/6 text-gray-600">
        By selecting this, you agree to our
        <a routerLink="/privacy" target="_blank" rel="noopener noreferrer" class="whitespace-nowrap font-semibold text-indigo-600">
          Privacy Policy 
        </a>
        and 
        <a routerLink="/terms" target="_blank" rel="noopener noreferrer" class="whitespace-nowrap font-semibold text-indigo-600">
           Terms of Service 
        </a>.
      </label>
      
    </div>
  
    <p *ngIf="hasError('agreeToPolicies')" class="error-text sm:col-span-2">
      You must agree to the Privacy Policy and Terms of Service.
    </p>

    <div class="flex gap-x-4 sm:col-span-2">
      <div class="flex h-6 items-center">
        <div
          class="group relative inline-flex w-8 shrink-0 rounded-full bg-gray-200 p-px outline-offset-2 outline-indigo-600 ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out has-[:checked]:bg-indigo-600 has-[:focus-visible]:outline has-[:focus-visible]:outline-2">
          <span
            class="size-4 rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-[:checked]:translate-x-3.5"></span>
  
          <input id="sms-opt-in" type="checkbox" aria-label="SMS Policy Consent"
            formControlName="smsOptIn" class="absolute inset-0 size-full appearance-none focus:outline-none" />
        </div>
      </div>
  
      <label for="sms-opt-in" class="text-sm/6 text-gray-600">
        By selecting this, you consent to receive recurring customer care text messages from Crown Wash at the mobile number you provided.
        Messages may include quote follow-ups, appointment confirmations, appointment reminders, arrival updates, service updates, billing notifications, and customer support messages. 
        Message frequency varies based on your quote requests, appointments, services, customer-initiated communications, and account activity.
        Message and data rates may apply. Reply STOP to unsubscribe or HELP for help. 
        Consent is optional and not a condition of receiving service. View our 
        <a routerLink="/terms" target="_blank" rel="noopener noreferrer" class="whitespace-nowrap font-semibold text-indigo-600">
           Terms of Service 
        </a> and our 
        <a routerLink="/privacy" target="_blank" rel="noopener noreferrer" class="whitespace-nowrap font-semibold text-indigo-600">
          Privacy Policy
        </a>.
        <span class="italic">Consent terms effective January 1, 2026</span>
      </label>
      
    </div>
  </div>
  <!-- <p class="mt-3 text-sm/6 text-gray-600"><span class="italic"><span class="text-red-600">*</span> Denotes a Required Field</span></p> -->
  <div class="mt-10">
    <button type="submit"
    class="block w-25 mx-auto rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
    Let's talk
      </button>
    </div>
  </form>

  <!-- <pre *ngIf="submittedPayload" class="mt-8 rounded-md bg-gray-900 p-4 text-sm text-white overflow-auto">
  {{ submittedPayload | json }}
  </pre> -->
</div>
 }
@if (formSubmitted) {
<div id="contact" class="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
  <!-- <div aria-hidden="true" class="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
    <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)" class="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"></div>
  </div> -->
  <div class="mx-auto max-w-2xl text-center">
    <h2 class="text-balance text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">Thanks for reaching out!</h2>
    <p class="mt-2 text-lg/8 text-gray-600">
      We've received your message. A member of our team will get back to you as soon as possible.
    </p>
    <p class="mt-2 text-lg/8 text-gray-600">
      We've also sent you an email confirmation for your records.
    </p>
  </div>
</div>
}